import { defineComponent as a, resolveComponent as l, openBlock as n, createElementBlock as p, createElementVNode as t, renderSlot as d, createBlock as s, normalizeClass as w } from "vue";
import _ from "../../atoms/VIcon/VIcon.js";
import { useToggle as h } from "../../../composables/useToggle.js";
import { _ as m } from "../../../_plugin-vue_export-helper-dad06003.js";
const b = a({
  name: "VAccordion",
  components: { VIcon: _ },
  setup(o) {
    const { state: e, toggle: r } = h();
    return {
      isOpen: e,
      toggleAccordion: r,
      ...o,
      randomId: () => Math.ceil(Math.random() * 2 ** 32)
    };
  }
});
const u = { class: "hobi-accordion tw-border-0 tw-border-b tw-border-solid tw-border-gray-300" }, g = ["aria-expanded", "aria-controls"], f = { class: "hobi-accordion__toggle-header-inner tw-flex tw-justify-between tw-items-start" }, v = { class: "hobi-accordion__head-icon-wrapper tw-flex-shrink-0 tw-ml-4 tw-h-10 tw-flex tw-justify-center tw-items-center" }, y = ["id"];
function k(o, e, r, $, I, V) {
  const i = l("VIcon");
  return n(), p("div", u, [
    t("button", {
      onClick: e[0] || (e[0] = (...c) => o.toggleAccordion && o.toggleAccordion(...c)),
      class: "hobi-accordion__toggle-header tw-relative tw-block tw-w-full tw-bg-transparent tw-border-0 tw-p-4 tw-pl-0 tw-cursor-pointer",
      "aria-expanded": o.isOpen,
      "aria-controls": `accordion-${o.randomId}`
    }, [
      t("div", f, [
        d(o.$slots, "header", { isOpen: o.isOpen }, void 0, !0),
        t("div", v, [
          o.isOpen ? (n(), s(i, {
            key: 0,
            symbol: "minus",
            width: 14,
            height: 14,
            color: "#424242",
            viewBox: "0 0 24 24"
          })) : (n(), s(i, {
            key: 1,
            symbol: "plus",
            width: 14,
            height: 14,
            color: "#424242",
            viewBox: "0 0 24 24"
          }))
        ])
      ])
    ], 8, g),
    t("div", {
      class: w([
        "hobi-accordion__content tw-overflow-hidden",
        o.isOpen ? "hobi-accordion__content--open tw-h-auto tw-pt-2 tw-pb-6" : "hobi-accordion__content--closed tw-h-0"
      ]),
      id: `accordion-${o.randomId}`
    }, [
      d(o.$slots, "default", {}, void 0, !0)
    ], 10, y)
  ]);
}
const j = /* @__PURE__ */ m(b, [["render", k], ["__scopeId", "data-v-5c134dd7"]]);
export {
  j as default
};
